import styled from 'styled-components';
import { LazyLoadImage } from 'shared/ui/organisms/lazy-load-image';

export const StyledImage = styled(LazyLoadImage)`
  border-radius: 50%;
`;
